import { UI, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React, { useEffect, useState } from 'react';

import { UserSelectionsProps } from '../..';
import { InputMoney } from '../../../../../../../../../../../../components/InputMoney';
import { usePublicOfferAssetEquityController } from '../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PublicOffer';

export interface PublicOfferEquityFieldsProps extends Required<UserSelectionsProps> {}

export const PublicOfferEquityFields: React.FC<PublicOfferEquityFieldsProps> = ({
  offer,
  offerDetails,
  selectedModality,
  setUserSelectionValues,
}) => {
  const [useMarketValue, setUseMarketValue] = useState(false);
  const id = offer.offerId;

  const {
    control,
    currentValue,
    currentValueFormatted,
    currentEquityValue,
    currentEquityValueFormatted,
    minimumValue,
    minimumEquityValue,
    handleInputValueBlur,
    handleInputValueClear,
    handleInputValueFocus,
    handleInputEquityValueBlur,
    handleInputEquityValueClear,
    handleInputEquityValueFocus,
    handleSubmit,
    hasErrorValue,
    hasErrorEquityValue,
    isValueFocused,
    isEquityValueFocused,
    minMaxValueDescription,
  } = usePublicOfferAssetEquityController(offer, offerDetails, selectedModality);

  useEffect(() => {
    setUserSelectionValues((prev) => ({
      ...prev,
      useMarketValueEquity: useMarketValue,
      currentEquityValue: useMarketValue ? undefined : currentEquityValue,
      currentValue,
      hasError: !!hasErrorValue || !!hasErrorEquityValue,
    }));
  }, [
    currentEquityValue,
    currentValue,
    hasErrorValue,
    hasErrorEquityValue,
    useMarketValue,
    id,
    setUserSelectionValues,
  ]);

  return (
    <VStack space="stack.xxxs">
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Valor desejado
        </UI.Text>

        <InputMoney
          id={`public-offer-value-input${id}`}
          name="priceItem"
          control={control}
          handleFocus={handleInputValueFocus}
          handleBlur={handleInputValueBlur}
          handleSubmit={handleSubmit}
          handleClear={handleInputValueClear}
          currentValue={currentValueFormatted}
          hasFocus={isValueFocused}
          minValue={minimumValue}
          customInputProps={{
            ...{ ...(isValueFocused && hasErrorValue && { error: hasErrorValue }) },
          }}
        />
      </VStack>
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Valor máximo por ação
        </UI.Text>

        <InputMoney
          isDisabled={useMarketValue}
          customPressableProps={{
            ...{ ...(useMarketValue && { bg: 'neutral.lightest', color: 'neutral.light' }) },
          }}
          id={`public-offer-equity-value-input${id}`}
          name="equityValue"
          control={control}
          handleFocus={handleInputEquityValueFocus}
          handleBlur={handleInputEquityValueBlur}
          handleSubmit={handleSubmit}
          handleClear={handleInputEquityValueClear}
          currentValue={currentEquityValueFormatted}
          hasFocus={isEquityValueFocused}
          minValue={minimumEquityValue}
          customInputProps={{
            ...{
              ...(isEquityValueFocused && hasErrorEquityValue && { error: hasErrorEquityValue }),
            },
          }}
        />
      </VStack>
      <UI.Text color="neutral.dark" fontSize={Typography['fontsize.xs']}>
        {minMaxValueDescription}
      </UI.Text>
      <UI.Checkbox
        testId={`second-copy-checkbox-${id}`}
        onChange={() => setUseMarketValue((prev) => !prev)}
        options={[{ label: 'A mercado', value: 'useMarketValue' }]}
        selectedValues={useMarketValue ? ['useMarketValue'] : []}
        optionPadding={{ bottom: 0, right: 0 }}
      />
    </VStack>
  );
};
